import { ITransferExamsDatasource } from './../datasources/transfer_exams_datasource';
import { ExamQueryResults } from './../builders/exam_query_results_builder';
import { Exam } from './../builders/exam_builder';
import { ICommand, IDefineCommand, IQueryMediator } from 'core-ts-types';

angular.module('capability-ng-transfer').factory(
  'searchTransferExamCommand',
  (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngExamBuilder: typeof Exam,
    ngTransferExamDatasource: ITransferExamsDatasource,
    ngExamQueryResultsBuilder: typeof ExamQueryResults,
    $http: ng.IHttpService
  ): ICommand => {
    return defineCommand(
      'searchTransferExamsCommand',
      (deferred: ng.IDeferred<any>, examTypeCode: string, queryText: string = '') => {
        const selectedExamIds = _.map(ngTransferExamDatasource.read(), (exam, id) => Number(id));
        $http({
          method: 'GET',
          url: `catalog/exam-type/${examTypeCode}/exam/`,
          params: {
            q: queryText,
            limit: 20
          }
        })
          .then((response: ng.IHttpPromiseCallbackArg<any>) => {
            const foundExams = {
              exams: _.reject(response.data.results, (exam: Exam) => selectedExamIds.includes(exam.id)),
              has_more: response.data.next !== null
            };
            // TODO how can we avoid this without getting examTypeCode from server?
            _.each(foundExams.exams, (exam: Exam) => {
              exam.exam_type_code = examTypeCode;
            });

            deferred.resolve(ngExamQueryResultsBuilder.build(foundExams));
          })
          .catch(deferred.reject);
      }
    );
  }
);



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/search_transfer_exams_command.ts